import {
  LanguageEnum,
  LocalisedStringObjectType,
  ProductCollectionItemObjectType,
  ReservationObjectType,
  UnitEnumType,
} from '../generated/graphql';
import { formatProductUnitAmount } from './number';

export function getLocalisedString(value: Array<LocalisedStringObjectType>, language: string = LanguageEnum.Nl) {
  let foundValue = value.find((i) => i.language === language);
  return foundValue ? foundValue.value : value[0]?.value || '';
}

export function getReservationProductsName(reservation: ReservationObjectType, language: string = LanguageEnum.Nl) {
  let nameValues: string[] = reservation.vendingProducts
    .filter((p) => !!p?.product?.name)
    .map((p) => {
      return `${formatProductUnitAmount(p.amount, p.product?.unitType ?? UnitEnumType.Unit)} ${
        p.product ? getLocalisedString(p.product.name, language) : '?????'
      }`;
    });
  return `${nameValues.slice(0, 2).join(', ')}${nameValues.length > 2 ? ', ...' : ''}`;
}

export function getReservationProductImages(reservation: ReservationObjectType): Array<string> {
  let newImages: string[] = [];
  for (let vendingProduct of reservation.vendingProducts) {
    if (vendingProduct?.product?.imageUrl) {
      newImages.push(vendingProduct.product.imageUrl);
      if (vendingProduct.product?.includedProducts?.length) {
        for (let includedProduct of vendingProduct.product.includedProducts) {
          if (includedProduct?.product?.imageUrl) {
            newImages.push(includedProduct.product.imageUrl);
          }
        }
      }
    }
  }
  return newImages.filter((img) => !!img);
}

export function getProductCollectionItemsSummary(
  products: Array<ProductCollectionItemObjectType>,
  language: LanguageEnum = LanguageEnum.Nl
) {
  return products
    .filter((p) => !!(p?.product?.unitType && p?.amount))
    .map((p) => {
      return `- ${formatProductUnitAmount(p.amount, p.product?.unitType ?? UnitEnumType.Unit)} ${
        p.product ? getLocalisedString(p.product.name, language) : '?????'
      }`;
    })
    .join('\n');
}

interface ReservationPrices {
  discountAmount: number;
  totalPrice: number;
  totalPriceWithDiscount: number;
}

export function getReservationPrices(reservation: ReservationObjectType): ReservationPrices {
  const vendingTotalPrice = reservation.vendingTotalPrice ?? 0;
  const vendingDiscount = reservation.vendingDiscount ? reservation.vendingDiscount / 10000 : 0;
  const discountAmount = vendingTotalPrice * vendingDiscount;
  const totalPriceWithDiscount = vendingTotalPrice - discountAmount;

  return {
    discountAmount,
    totalPriceWithDiscount,
    totalPrice: reservation.vendingTotalPrice ?? 0,
  };
}
